import axios from 'axios';

const STORAGE_KEY = 'leilancer_acquisition';
let hooksInstalled = false;

const safeStorage = () => {
  try { return window.localStorage; } catch { return null; }
};

const clean = (value, max = 255) => {
  const v = String(value || '').trim();
  return v ? v.slice(0, max) : null;
};

const sameOriginReferrer = () => {
  if (typeof window === 'undefined' || !document.referrer) return null;
  try {
    const url = new URL(document.referrer);
    return url.origin === window.location.origin ? url : null;
  } catch {
    return null;
  }
};

export function captureAttribution() {
  if (typeof window === 'undefined') return null;
  const storage = safeStorage();
  const params = new URLSearchParams(window.location.search || '');
  const referrerUrl = sameOriginReferrer();
  const refParams = referrerUrl?.searchParams || null;
  const pick = (name) => params.get(name) || refParams?.get(name) || null;

  // /plataforma e outras LPs publicas sao HTML estatico e nao executam este
  // modulo React. Ao clicar em /register, o navegador preserva a URL completa
  // da pagina anterior no referrer (mesma origem). Recuperamos as UTMs/fbclid
  // dali para que a atribuicao nao se perca na transicao LP -> cadastro.
  const cameFromCampaignReferrer = !!(
    refParams?.get('utm_source') ||
    refParams?.get('utm_medium') ||
    refParams?.get('utm_campaign') ||
    refParams?.get('utm_content') ||
    refParams?.get('utm_term') ||
    refParams?.get('fbclid')
  );

  const landingPage = cameFromCampaignReferrer && !window.location.search
    ? `${referrerUrl.pathname}${referrerUrl.search}`
    : `${window.location.pathname}${window.location.search}`;

  const incoming = {
    utm_source: clean(pick('utm_source'), 120),
    utm_medium: clean(pick('utm_medium'), 120),
    utm_campaign: clean(pick('utm_campaign'), 191),
    utm_content: clean(pick('utm_content'), 191),
    utm_term: clean(pick('utm_term'), 191),
    fbclid: clean(pick('fbclid'), 255),
    landing_page: clean(landingPage, 500),
    referrer: clean(document.referrer, 500),
    captured_at: new Date().toISOString(),
  };

  let previous = null;
  try { previous = JSON.parse(storage?.getItem(STORAGE_KEY) || 'null'); } catch { previous = null; }

  const hasCampaign = !!(incoming.utm_source || incoming.utm_medium || incoming.utm_campaign || incoming.utm_content || incoming.fbclid);
  const result = previous && !hasCampaign
    ? previous
    : { ...(previous || {}), ...Object.fromEntries(Object.entries(incoming).filter(([, v]) => v !== null)) };

  try { storage?.setItem(STORAGE_KEY, JSON.stringify(result)); } catch { /* sem storage */ }
  return result;
}

export function getAttribution() {
  if (typeof window === 'undefined') return null;
  const storage = safeStorage();
  try {
    return JSON.parse(storage?.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
}

export function installAttributionHooks() {
  if (hooksInstalled) return;
  hooksInstalled = true;

  axios.interceptors.response.use((response) => {
    try {
      const url = String(response?.config?.url || '');
      const token = response?.data?.token;
      if (token && url.includes('/api/auth/cadastro-direto')) {
        const attribution = getAttribution();
        if (attribution) {
          const API_URL = process.env.REACT_APP_API_URL || '';
          axios.post(`${API_URL}/api/usuarios/attribution`, attribution, {
            headers: { Authorization: `Bearer ${token}` },
          }).catch(() => {});
        }
      }
    } catch { /* atribuicao nunca pode bloquear o cadastro */ }
    return response;
  }, (error) => Promise.reject(error));
}
